import { h, VNode } from 'preact';
import Widget from '@components/organisms/widget/widget';
import { ThemeProvider } from 'styled-components';
import { uk2, westhost, midphase, FEEDBACK_PLACEMENT, defaultPositions } from '@styles/theme';
import { useBrandSettings, setupBrandSettings } from '@hooks/useBrandSettings';
import { useEffect } from 'preact/hooks';
import { setupEnv } from '@hooks/useEnv';
import { useSignal } from '@preact/signals';

const setupVariables = (props) => {
  setupBrandSettings(props);
  setupEnv(props);
};

const App = (props): VNode => {
  setupVariables(props);

  const { brand, placement, useBrandColors, variant } = useBrandSettings();
  const theme = useSignal(uk2);

  useEffect(() => {
    switch (brand) {
      case 'midphase':
        theme.value = midphase;
        break;
      case 'westhost':
        theme.value = westhost;
        break;
      default:
        theme.value = uk2;
        break;
    }
  });

  const adjustedWidgetPositions = {
    position: {
      ...defaultPositions.position,
      desktop: {
        ...defaultPositions.position.desktop,
        ...FEEDBACK_PLACEMENT[placement],
      },
    },
  };

  const themeInfo = {
    useBrandColors,
    isUK2: brand === 'uk2',
    isWH: brand === 'westhost',
  };

  return (
    <ThemeProvider theme={{ ...theme.value, ...adjustedWidgetPositions, ...themeInfo }}>
      <Widget />
    </ThemeProvider>
  );
};

export default App;
